module.exports = "<div id=\"footer\">\n    <a href=\"http://redash.io\">Redash</a> <span ng-bind=\"$ctrl.version\"></span> <small ng-if=\"$ctrl.newVersionAvailable\" ng-cloak class=\"ng-cloak\"><a href=\"https://version.redash.io/\">(New Redash version available)</a></small>\n    &#8226;\n    <a href=\"https://redash.io/help/\">Documentation</a>\n    &#8226;\n    <a href=\"http://github.com/getredash/redash\">Contribute</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/footer/footer.html
// module id = 395
// module chunks = 1